import type { SiteId, SiteVertical } from '../../enums';
import type { CreateUserPayloadOptions, CreateUserPayloadReturn } from '../createUserPayload';
import { ActionType } from '../../enums';
import { createUserPayload } from '../createUserPayload';

export interface CreatePageViewEventPayloadOptions {
  location: string;
  pageTitle: string;
  pageType: string;
  referrer: string;
  siteId: SiteId;
  siteVertical: SiteVertical;
  user: CreateUserPayloadOptions;
}

export interface CreatePageViewEventPayloadReturn {
  content: {
    page_location: string;
    page_referrer: string;
    page_title: string;
    page_type: string;
  };
  event_data: {
    action: ActionType;
  };
  site: {
    site_id: SiteId;
    site_vertical: SiteVertical;
  };
  user: CreateUserPayloadReturn;
}

export const createPageViewEventPayload = ({
  siteId,
  siteVertical,
  location,
  referrer,
  pageType,
  pageTitle,
  user,
}: CreatePageViewEventPayloadOptions): CreatePageViewEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.VIEW,
    },
    site: {
      site_id: siteId,
      site_vertical: siteVertical,
    },
    content: {
      page_location: location,
      page_referrer: referrer,
      page_type: pageType,
      page_title: pageTitle,
    },
    user: createUserPayload(user),
  };
};
